import Control from "ol/control/Control";
import * as msal from "@azure/msal-browser";
import { getMsalObjPromise } from "../auth/getMsalObj";

export class AzureLoginControl extends Control {
  constructor() {
    const div = document.createElement("div");
    div.className = "login";
    super({ element: div });
    const this_ = this;

    getMsalObjPromise().then((msalObj) => {
      const account = msalObj.getAllAccounts()[0];
      const request = {
        account: account,
        scopes: ["https://storage.azure.com/user_impersonation"],
      };
      msalObj
        .acquireTokenSilent(request)
        .then(function (tokenResponse) {
          this_.set("idToken", tokenResponse.idToken);
          this_.set("idTokenClaims", tokenResponse.idTokenClaims);
        })
        .catch(function (error) {
          console.log(error);
          if (
            error instanceof msal.InteractionRequiredAuthError ||
            error instanceof msal.BrowserAuthError
          ) {
            msalObj.acquireTokenRedirect(request);
          }
        });
    });

    const button = document.createElement("button");
    button.textContent = "Log In";
    button.className = "login-btn";
    div.appendChild(button);

    this.on("propertychange", function (e) {
      if (e.key === "idToken" && e.target.get("idToken")) {
        button.textContent = "Logged In";
        button.style.background = "#3CB371";
      }
    });
  }
}
